import React, { FC } from "react";
import { Button, Tooltip } from "antd";
import { CalendarOutlined, CheckCircleFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import styles from "./timeline-indicator.module.css";

const {
  ["timeline-indicator"]: timelineIndicatorClassName,
  ["completion-indicator"]: completionIndicatorClassName,
} = styles as any;

type Props = {
  onClick: (e: React.MouseEvent) => void;
  isComplete: boolean;
  size?: "small" | "middle" | "large";
  startDate?: Date | null;
  deadlineDate?: Date | null;
};

export const TimelineIndicator: FC<Props> = ({
  onClick,
  isComplete,
  size = "middle",
  startDate,
  deadlineDate,
}) => {
  const getTooltipTitle = () => {
    if (!startDate && !deadlineDate) return "";

    const formatDate = (date: Date | undefined) => (date ? dayjs(date).format("MMM D, YYYY") : "");
    if (startDate && deadlineDate) {
      return `${formatDate(startDate)} - ${formatDate(deadlineDate)}`;
    }
    if (startDate) {
      return `Starts: ${formatDate(startDate)}`;
    }
    if (deadlineDate) {
      return `Due: ${formatDate(deadlineDate)}`;
    }
    return "";
  };

  return (
    <div className={timelineIndicatorClassName}>
      <Tooltip title={getTooltipTitle()} placement="left">
        <Button
          size={size}
          shape="circle"
          icon={<CalendarOutlined />}
          type="link"
          onClick={onClick}
        />
      </Tooltip>
      {isComplete && (
        <span className={completionIndicatorClassName}>
          <CheckCircleFilled style={{ fontSize: "12px" }} />
        </span>
      )}
    </div>
  );
};
